// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".features-content[data-v-38fde3be]{max-width:900px}", ""]);
// Exports
module.exports = exports;
